import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Heading } from '@sainsburys-tech/luna-typography'

const ModalHeading = ({ className, ...props }) => (
  <Heading
    {...props}
    className={classnames('ln-c-modal__heading', className)}
  />
)

ModalHeading.propTypes = {
  className: PropTypes.string,
}

ModalHeading.defaultProps = {
  className: undefined,
}

ModalHeading.displayName = 'ModalHeading'

ModalHeading.propTypes = {
  className: PropTypes.string,
}

ModalHeading.defaultProps = {
  className: undefined,
}

export default ModalHeading
